<div class="wrapper">
  <div class="dates">
    <div class="date-row">
      <p-carousel
        [value]="dates"
        [numVisible]="7"
        [numScroll]="7"
        [showIndicators]="false"
        [page]="activeIndex > 6 ? 1 : 0"
        [circular]="false"
      >
        <ng-template let-date pTemplate="item">
          <span
            class="date-tab"
            [title]="
              date.status === dataStatus.fileMissing
                ? 'XML-fil för givet datum saknas'
                : date.status === dataStatus.analysisMissing
                  ? 'Provdata för givet datum saknas'
                  : date.date
            "
            [class.date-missing]="date.status === dataStatus.fileMissing"
            [class.analysis-missing]="date.status === dataStatus.analysisMissing"
            [class.selected]="date.status === dataStatus.full && activeIndex === dates.indexOf(date)"
            [class.selected-missing]="date.status !== dataStatus.full && activeIndex === dates.indexOf(date)"
            (click)="getDate(date)"
          >
            {{ date.date }}
          </span>
        </ng-template>
      </p-carousel>
    </div>
  </div>
  @if (loading) {
    <div class="text-center mb-2">
      <i class="fa fa-spinner fa-spin display-1"></i>
    </div>
  } @else if (currentFind) {
    <div class="fynd px-4" *ngFor="let fynd of currentFind.finds">
      <h3 class="smittamne">
        {{ fynd.smittamneName }}
      </h3>

      <div class="antibiotika-result">
        <div class="grid header">
          <span>Antibiotika</span>
          <span>Diskstyrka</span>
          <span>SIR</span>
          <span>Zon</span>
          <span>Tolkning MIC</span>
          <span>MIC</span>
        </div>

        <div class="grid" *ngFor="let antibiotika of fynd.antimicroList">
          <span>{{ antibiotika.name }}</span>
          <span>{{ antibiotika.diskStyrka }}</span>
          <span>{{ antibiotika.sir !== "" ? antibiotika.sir : "-" }}</span>
          <span>{{ antibiotika.zon ?? "-" }}</span>
          <span>{{ antibiotika.tolk !== "" ? antibiotika.tolk : "-" }}</span>
          <span>{{ antibiotika.mic ?? "-" }}</span>
        </div>
      </div>
    </div>
  } @else {
    <p class="px-4 brodtext-medium-14">{{ missingResultInfo }}</p>
  }
</div>
